import { useEffect, useState } from "react";
import { fetchPointsSummary } from "./mockPoints";
import type { PointsSummary } from "./pointsTypes";

/** 讀某瓦斯行帳戶的點數（餘額＋異動）。contextId 變動時重抓，卸載後不寫入 state。 */
export const usePointsSummary = (contextId: string | null | undefined) => {
  const [summary, setSummary] = useState<PointsSummary | null>(null);
  const [loading, setLoading] = useState(!!contextId);

  useEffect(() => {
    let alive = true;
    if (!contextId) {
      setSummary(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    fetchPointsSummary(contextId)
      .then((data) => {
        if (alive) setSummary(data);
      })
      .catch(() => {
        // 點數是加值資訊，抓不到就當作沒有（不擋下單、不跳錯）
        if (alive) setSummary(null);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [contextId]);

  return { summary, loading, balance: summary?.balance ?? { storedGas: 0, account: 0 } };
};
